import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Modal, TextField, useFormField } from '@frontend/design-system';

export const EditBreakModal = ({
  name,
  existingBreakNames = [],
  onCancel,
  onDone,
}: {
  name: string;
  existingBreakNames?: string[];
  onCancel: () => void;
  onDone: (newName: string) => void;
}) => {
  const { t } = useTranslation('phone');

  const fieldProps = useFormField({
    type: 'text',
    value: name,
    required: true,
    validator: ({ value }) => {
      const conflictExists = existingBreakNames.find((name) => {
        return name?.trim().toLowerCase() === value.trim().toLowerCase();
      });
      if (conflictExists) {
        return t('Break name "{{breakName}}" is already in use', { breakName: value });
      }
      return '';
    },
  });

  return (
    <>
      <Modal.Header onClose={onCancel}>{t('Rename Break')}</Modal.Header>
      <Modal.Label>{name}</Modal.Label>
      <Modal.Body
        css={css`
          margin-top: ${theme.spacing(2)};
        `}
      >
        <TextField {...fieldProps} name='breakName' label='Break Name' />
      </Modal.Body>

      <Modal.Footer
        css={css`
          display: flex;
          justify-content: space-between;
        `}
      >
        <div
          css={css`
            display: flex;
            gap: ${theme.spacing(2)};
            margin-left: auto;
          `}
        >
          <Button variant='secondary' onClick={onCancel}>
            {t('Cancel')}
          </Button>
          <Button
            onClick={() => {
              onDone(fieldProps.value);
            }}
            disabled={!fieldProps.value || !!fieldProps.error}
          >
            {t('Done')}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};
